// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import toggleFiltersOpen from "@insite/client-framework/Store/Pages/SavedOrderList/Handlers/ToggleFiltersOpen";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonIconPresentationProps, ButtonPresentationProps } from "@insite/mobius/Button";
import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconPresentationProps } from "@insite/mobius/Icon";
import Filter from "@insite/mobius/Icons/Filter";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
/* Starter Custom Code - End */

const mapDispatchToProps = {
    toggleFiltersOpen,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps>;

export interface SavedOrderListHeaderStyles {
    container?: GridContainerProps;
    titleGridItem?: GridItemProps;
    emptyGridItem?: GridItemProps;
    toggleFilterGridItem?: GridItemProps;
    /** @deprecated Use toggleFilterButtonIcon instead. */
    toggleFilterIcon?: IconPresentationProps;
    /** @deprecated Use toggleFilterButton instead. */
    toggleFilterClickable?: ClickablePresentationProps;
    toggleFilterButton?: ButtonPresentationProps;
    toggleFilterButtonIcon?: ButtonIconPresentationProps;
    // Starter Custom Code
    heading?: TypographyPresentationProps;
}

export const savedOrderListHeaderStyles: SavedOrderListHeaderStyles = {
    heading: { variant: "h1" },
};
const styles = savedOrderListHeaderStyles;

const SavedOrderListHeader = ({ toggleFiltersOpen, id }: Props) => {
    /* Starter Custom Code - Start */
    const currentPage = useCurrentPage();

    return <Typography {...styles.heading}>{currentPage.fields.title}</Typography>;
    /* Starter Custom Code - End */
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(SavedOrderListHeader),
    definition: {
        group: "Saved Order List",
        displayName: "Header",
        allowedContexts: ["SavedOrderListPage"],
    },
};

export default widgetModule;
